import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { CandidateParam } from "./params";
import { PositionGroup } from "./company";
import Auth from "@/lib/common/auth";

// 自动交卷类型
export enum EnumAutoSubmitType {
  Normal = 0, // 默认正常交卷
  Timeout = 1, // 答题超时
  Screenshot, // 截屏
  MobileJoinCount, // 切屏
  Lr1, // 人脸核验失败
  Lr2, // 人脸核验失败超过最大次数
  Expire, // 面试过期
  Repeat, // 新增邀请记录触发强制交卷,
  NameIdCheck = 14
}

// 通知状态
export enum EnumMessageStatus {
  EnumMessageStatusOpenLink, // 公开链接
  EnumMessageStatusNoSend, // 定向邀请 未通知
  EnumMessageStatusNoReply, // 定向邀请 已通知未打开
  EnumMessageStatusApply // 定向邀请 已通知已经打开
}

// 付款状态
export enum EnumCostStatus {
  EnumCostStatusNormal, // 未付款
  EnumCostStatusFinish = 2 // 已付款
}

//ai执行状态
export enum EnumProcessStatus {
  EnumProcessStatusNormal = 1, // 未开始
  EnumProcessStatusRunning, // 执行中
  EnumProcessStatusFinish, // 完成
  EnumProcessStatusNoNeed = 255 // 无需执行
}

//ai推荐状态
export enum EnumAiRecommendStatus {
  EnumAiRecommendStatusDefault, // 默认
  EnumAiRecommendStatusNotRecommend = 10, // 不推荐
  EnumAiRecommendStatusNormal = 20, // 一般
  EnumAiRecommendStatusRecommend = 30, // 推荐
  EnumAiRecommendStatusVeryRecommend = 40 // 非常推荐
}

//评估状态-ai
export enum EnumAuditStatus {
  EnumAuditStatusNoAudit, // 待评估
  EnumAuditStatusPass, // 通过
  EnumAuditStatusWait, // 待定
  EnumAuditStatusRefuse // 拒绝
}

// 错误项任务名
export enum EnumErrorInfoTask {
  EnumErrorInfoTaskDefault = "",
  EnumErrorInfoTaskFaceCheck = "livenessRecognition", // 人脸检测-身份认证失败
  EnumErrorInfoTaskBgCheckIdentity = "bgCheckIdentity", // 背调-手机号实名认证
  EnumErrorInfoTaskBgCheckSocial = "bgCheckSocial", // 背调-社会安全
  EnumErrorInfoTaskBgCheckFinancial = "bgCheckFinancial", // 背调-金融
  EnumErrorInfoTaskColor = "colorDetection", // 色盲检测
  EnumErrorInfoTaskFinger = "handDetection", // 手部检测
  EnumErrorInfoTaskFace = "faceDetection", // 脸部检测
  EnumErrorInfoTaskReplacePerson = "replacementPerson", // 换人检测
  EnumErrorInfoTaskFaceDetection = "faceShowDetection", // 露脸检测
  EnumErrorInfoTaskFaceMultiple = "multiplePersonDetection", // 多人检测
  EnumErrorInfoTaskScreenshot = "screenshotDetection", // 截屏检测
  EnumErrorInfoTaskMobileJoinCountCheck = "jumpOutDetection" // 跳出检测
}

// 排序
export enum EnumCandidateListSortKey {
  ScoreAll = "score_all", // 总分
  ScoreAi = "score_ai", // AI分
  SubmitTime = "submit_time", // 提交时间
  CreatedTime = "created_time", // 创建时间
  LastOperationTime = "last_operation_time", // 末次操作时间
  BeginTime = "begin_time" // 开始答题时间
}

// 提交状态
export enum EnumSubmitStatus {
  EnumSubmitStatusNotSignIn, // 定向邀请 未登记
  EnumSubmitStatusAnswering, // 答题中
  EnumSubmitStatusFinish, // 已交卷
  EnumSubmitStatusSignIn, // 公开链接 已登记
  EnumSubmitStatusNoScore // 已交卷未评分 临时中间状态
}

export class CandidateSearch extends Model {
  companyId = Auth.companyId;
  examId = 0;
  examVersionId = 0; // 面试版本Id
  candidateIdList: number[] = []; // 仅查询指定id的候选人
  searchKey = ""; // 姓名或电话或链接码或身份证号或登录id
  loginId = ""; // 登录id
  positionId = 0; // 岗位id
  tagNameList: string[] = []; // 标签
  aiRecommendStatusList: EnumAiRecommendStatus[] = []; // AI推荐状态筛选
  submitStatusList: EnumSubmitStatus[] = []; // 阅卷状态筛选
  createdTime: string[] = [];
  beginTime: string[] = []; // 开始面试时间筛选
  submitTime: string[] = []; // 面试完成时间筛选
  afterBuy = 0; // 只搜索购买后
  afterReport = 0; // 只返回有报告的
  onlyCount = false;
  sortKey = "";
  sortDict = "";
  page = 1;
  pageSize = 10;
  returnAll = false; // 是否返回全量,忽略分页,仅部分接口生效
  connectCodeList: string[] = []; // 链接码列表

  public objectArrayClasses() {
    return {
      candidateIdList: 0
    };
  }
}

export class ErrorInfo extends Model {
  task = EnumErrorInfoTask.EnumErrorInfoTaskDefault; //考察项名称
  result = 0; //1异常 其他正常
  resMessage = ""; //结果文案
}
// 购买查看报告请求
export class CandidateBuy {
  candidateId = 0;
  companyId = 0;
}

export class CandidateItem extends Model {
  candidateId = 0; // 候选人id
  connectCode = ""; // 链接码
  companyId = 0; // 公司id
  loginId = 0; // 登录id
  showName = ""; // 姓名
  phone = ""; // 电话
  email = ""; // 邮件
  idNumber = ""; // 身份证号
  photoUrl = ""; // 头像链接
  remark = ""; // 备注
  createdTime = ""; // 创建时间
  beginTime = ""; // 开始答题时间
  submitTime = ""; // 提交答题时间
  submitStatus = EnumSubmitStatus.EnumSubmitStatusNotSignIn; // 提交状态
  isAutoSubmit = 0; // 是否自动提交
  autoSubmitType = EnumAutoSubmitType.Normal; // 自动提交类型
  messageStatus = EnumMessageStatus.EnumMessageStatusOpenLink; // 通知状态
  costStatus = EnumCostStatus.EnumCostStatusNormal; // 付款状态
  aiProcessStatus = EnumProcessStatus.EnumProcessStatusNormal; // ai执行状态
  auditStatus = EnumAuditStatus.EnumAuditStatusNoAudit; // 评估状态
  auditMember = ""; // 评估人员
  examId = 0; // 面试id
  examVersionId = 0; // 面试批次id
  examName = ""; // 面试名称
  examRemark = ""; // 面试备注
  positionId = 0; // 岗位id
  positionName = ""; // 岗位名
  scoreAi = 0; // ai打分
  scoreHr = 0; // hr打分
  score = 0; // 总得分
  aiRecommendStatus = EnumAiRecommendStatus.EnumAiRecommendStatusDefault; // ai推荐状态
  isRepeatExam = 0; // 是否是单公司跨面试重复
  isRepeat = false; // 是否单面试下重复
  isRepeatExamCount = 0; // 单公司跨面试重复次数
  isRepeatCount = 0; // 单面试下重复次数
  isRepeatCreate = 0; // 是否重复邀请逻辑创建
  tags = [""]; // 标签
  errorInfoList = [new ErrorInfo()]; // 异常检测项
  aiComment = ""; // ai评价
  paramList = [new CandidateParam()]; // 登记信息

  // 购买查看报告
  static candidateBuy(buyForm: CandidateBuy) {
    return request.postInterviewApi("hr/candidate/buy", buyForm).then(resp => {
      return resp.data;
    });
  }

  static delete(id: number) {
    return request
      .postInterviewApi("hr/candidate/delete", { candidateId: id })
      .then(res => {
        return res.data;
      });
  }

  static mDelete(ids: number[]) {
    return request
      .postInterviewApi("hr/candidate/mDelete", {
        candidateIdList: ids,
        companyId: Auth.companyId
      })
      .then(res => {
        return res.data;
      });
  }

  static create(params: CandidateCreateOne) {
    return request.postInterviewApi("hr/candidate/create", params).then(res => {
      return res.data;
    });
  }

  static mCreate(params: CandidateCreateMore) {
    return request
      .postInterviewApi("hr/candidate/mCreate", params)
      .then(res => {
        return res.data;
      });
  }

  static saveRemark(candidateId: number, remark: string) {
    return request
      .postInterviewApi("hr/candidate/saveRemark", {
        companyId: Auth.companyId,
        candidateId,
        remark
      })
      .then(res => {
        return res.data;
      });
  }

  static addTags(candidateId: number, tags: string[]) {
    return request
      .postInterviewApi("hr/candidate/appendTags", {
        companyId: Auth.companyId,
        candidateId,
        tags
      })
      .then(res => {
        return res.data;
      });
  }

  static mAddTags(
    candidateIdList: number[],
    tags: string[],
    isReplace = false
  ) {
    return request
      .postInterviewApi("hr/candidate/mAppendTags", {
        companyId: Auth.companyId,
        candidateIdList,
        tags,
        isReplace
      })
      .then(res => {
        return res.data;
      });
  }

  static delTags(candidateId: number, tags: string[]) {
    return request
      .postInterviewApi("hr/candidate/deleteTags", {
        companyId: Auth.companyId,
        candidateId,
        tags
      })
      .then(res => {
        return res.data;
      });
  }

  static sendAsk(candidateId: number, env: 0 | 1) {
    const uri =
      env === 0
        ? "hr/candidate/sendInviteMessage"
        : "hr/candidate/sendResultMessage";

    return request
      .postInterviewApi(uri, {
        companyId: Auth.companyId,
        candidateId,
        sendMobile: true,
        sendEmail: true
      })
      .then(resp => {
        return resp.data;
      });
  }

  static mSendAsk(candidateIdList: number[], env: 0 | 1) {
    const uri =
      env === 0
        ? "hr/candidate/mSendInviteMessage"
        : "hr/candidate/mSendResultMessage";

    return request
      .postInterviewApi(uri, {
        companyId: Auth.companyId,
        candidateIdList,
        sendMobile: true,
        sendEmail: true
      })
      .then(resp => {
        return resp.data;
      });
  }

  static repeatCreate(params: CandidateRepeatCreate) {
    return request
      .postInterviewApi("hr/candidate/repeatCreate", params)
      .then(res => {
        return res.data;
      });
  }

  static repeatMCreate(params: CandidateRepeatMCreate) {
    return request
      .postInterviewApi("hr/candidate/repeatMCreate", params)
      .then(res => {
        return res.data;
      });
  }
}

export class CandidateExportPdfParam extends Model {
  needExportVideo = false; // 是否需要导出视频
  companyId = 0; // 公司id
  examIdList: number[] = []; // 查询多场面试
  examId = 0; // 查询单场面试
  examVersionId = 0; // 查询单场面试批次
  candidateIdList: number[] = []; // 仅查询指定id的候选人
  searchKey = ""; // 姓名或电话或链接码或身份证号或登录id或备注
  loginId = ""; // 登录id
  positionId = 0; // 岗位id
  tagNameList: string[] = []; // 标签筛选
  aiRecommendStatusList: EnumAiRecommendStatus[] = []; // AI推荐状态筛选
  submitStatusList: EnumSubmitStatus[] = []; // 提交状态筛选
  auditStatusList: EnumAuditStatus[] = []; // 评估状态筛选
  createdTime: string[] = []; // 创建时间筛选
  beginTime: string[] = []; // 开始时间筛选
  submitTime: string[] = []; // 提交时间筛选
  afterBuy = 0; // 是否只搜索已付费
  afterReport = 0; // 是否只搜索已生成报告
  sortKey = ""; // 排序键
  sortDict = ""; // 排序方向

  public objectArrayClasses() {
    return {
      candidateIdList: 0
    };
  }
}

export class CandidateList extends Model {
  list = [new CandidateItem()];
  count = 0; // 总计
  page = 0; // 当前分页
  pageSize = 0; // 当前页大小
  pageMax = 0; // 最大有效分页

  static getList(param: CandidateSearch) {
    return request.postInterviewApi("hr/candidate/list", param).then(res => {
      return new CandidateList().assign(res.data.data);
    });
  }

  static export(param: CandidateSearch) {
    return request
      .postInterviewApi("hr/candidate/listExport", param)
      .then(res => {
        return res.data;
      });
  }

  static exportPdf(param: CandidateExportPdfParam) {
    return request
      .postInterviewApi("hr/candidate/pdfExport", param)
      .then(res => {
        return res.data;
      });
  }

  static getIdList(param: CandidateSearch) {
    return request.postInterviewApi("hr/candidate/listIds", param).then(res => {
      return res.data;
    });
  }
}

export class CandidateFeatures extends Model {
  positionGroups: PositionGroup[] = [];
  tag = [""];
  paramName = [""];

  public objectArrayClasses() {
    return {
      positionGroups: PositionGroup
    };
  }

  static get() {
    return request
      .postInterviewApi("hr/candidate/listFeatures", {
        companyId: Auth.companyId
      })
      .then(res => {
        return new CandidateFeatures().assign(res.data.data);
      });
  }
}

export class CandidateCreateOne {
  examId = 0;
  loginId = "";
  showName = "";
  phone = "";
  email = "";
  idNumber = "";
  tags = [];
  sendMessage = 0;
}

export class CandidateCreateParse {
  companyId = Auth.companyId;
  examId = 0;
  ossUrl = "";
  needExport = 0;
  needSort = 0;

  static createParse(params: CandidateCreateParse) {
    return request
      .postInterviewApi("hr/candidate/mCreateParse", params)
      .then(res => {
        return res.data;
      });
  }
}

export class CandidateCreateParseItem extends Model {
  isOk = false;
  errorMsg = "";
  loginId = "";
  showName = "";
  phone = "";
  email = "";
  tagList: string[] = [""];
  candidateId = 0;
  submitStatus = 0;
}

export class CandidateCreateParseLimit extends Model {
  createLimit = {
    limit: 0,
    used: 0,
    current: 0
  };
  noAnswerLimit = {
    limit: 0,
    used: 0,
    current: 0
  };
}

export class CandidateCreateParseRes extends Model {
  count = 0;
  countOk = 0;
  excelUrl = "";
  list: CandidateCreateParseItem[] = [];
  limitInfo = new CandidateCreateParseLimit();

  public objectArrayClasses() {
    return {
      list: CandidateCreateParseItem
    };
  }
}

export class CandidateCreateItem {
  loginId = "";
  showName = "";
  phone = "";
  email = "";
  tagList = [""];
}

export class CandidateCreateMore {
  companyId = Auth.companyId;
  examId = 0;
  candidateList: CandidateCreateItem[] = [];
  sendMessage = 0;

  static getExcel(id: number) {
    return request
      .postInterviewApi("hr/exam/exportTemplate", { examId: id })
      .then(res => {
        return res.data;
      });
  }
}

export class CandidateRepeatCreate {
  candidateId = 0;
  autoSubmit = 2; // 候选人是否自动提交
  sendMessage = 2; // 是否发送通知
}

export class CandidateRepeatMCreate {
  companyId = Auth.companyId;
  candidateIdList: number[] = [];
  autoSubmit = 2; // 候选人是否自动提交
  sendMessage = 2; // 是否发送通知
}
